import {
  apiBaseUrl
} from 'yxt-biz-pc/packages/api';

export const getSkillTemplateDetail = (id) => {
  return apiBaseUrl.get(`sptalentsd/mgr/model/skillmodel/${id}`);
};
